/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class MiniCart extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    fetch(this.dataset.url).then(response => response.text()).then(html => {
      document.getElementById('mini-cart').innerHTML = this.getSectionInnerHTML(html, '.shopify-section');
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
    }).catch(e => {
      console.error(e);
    });
  }
  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    this.drawer.openMenuDrawer();
  }
  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach(section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });
    this.open();
    setTimeout(() => {
      this.focusOnCartDrawer();
    }, 100);
  }
  getSectionsToRender() {
    return [{
      id: 'mini-cart',
      section: 'mini-cart',
      selector: '.shopify-section'
    }, {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }, {
      id: 'mobile-cart-icon-bubble',
      section: 'mobile-cart-icon-bubble',
      selector: '.shopify-section'
    }];
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
  focusOnCartDrawer() {
    const closeButton = document.querySelector('.mini-cart__header drawer-close-button');
    if (!closeButton) return;
    closeButton.focus();
    setTimeout(() => {
      if (document.activeElement !== closeButton) {
        closeButton.focus();
      }
    }, 50);
  }
}
customElements.define('mini-cart', MiniCart);
const initIOSCartDrawerLock = () => {
  const isTouchingIOS = () => {
    const platform = window.navigator.platform || '';
    const ua = window.navigator.userAgent || '';
    const maxTouchPoints = window.navigator.maxTouchPoints || 0;
    return /iP(ad|hone|od)/.test(platform) || /iPad|iPhone|iPod/.test(ua) || platform === 'MacIntel' && maxTouchPoints > 1;
  };
  if (!isTouchingIOS()) return;
  const details = document.querySelector('cart-drawer details');
  if (!details) return;
  let scrollPosition = 0;
  details.addEventListener('toggle', () => {
    if (details.hasAttribute('open')) {
      scrollPosition = window.scrollY || window.pageYOffset;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = '100%';
    } else {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollPosition);
    }
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initIOSCartDrawerLock);
} else {
  initIOSCartDrawerLock();
}
/******/ })()
;